<template>
	<div style="overflow-x: hidden !important">
		<div class="main">
			<div class="hero">
				<div class="left">
					<div class="hero-title">
						<h1>{{ $t("browse-layout") }}</h1>
					</div>
					<div class="hero-subtitle">
						<h5>{{ computedText }}</h5>
					</div>
					<search
						:loadDocs="true"
						:loadFolders="true"
						:folderID="undefined"
						from="browse-layout"
						@docSelected="
							item => {
								viewInfo(item.id, item.UniqueID)
							}
						"
						@folderSelected="
							item => {
								goto('/browse/folders/' + item.id)
							}
						"
						@keyup="str => {}"
					/>
				</div>
				<div class="right">
					<img :src="img" alt="Documents" />
				</div>
			</div>

			<div class="content">
				<div class="folders">
					<div class="folders-title">{{ $t("folders") }}</div>
					<div class="folders-container">
						<div class="box-container">
							<div v-if="expired">
								<div
									style="
										display: flex;
										width: 100%;
										justify-content: space-around;
										align-items: center;
										height: 100%;
									"
								>
									<div>
										<md-icon class="md-size-2x" style="color: #f56c6c">warning</md-icon>
									</div>
									<div style="font-size: 1.2em; margin-left: 10px; font-weight: 500">
										{{ $t("expired-subscription-content") }}
									</div>
								</div>
							</div>
							<div
								class="box1"
								v-for="(f, i) in folders"
								:key="i"
								@click="goto('/browse/folders/' + f.folder.id)"
								v-else
							>
								<div class="folders-icon">
									<md-icon class="md-size-3x" style="color: #fbbc04">folder</md-icon>
								</div>
								<div style="display: flex; height: 100%; align-items: flex-end; text-align: center">
									<div class="folders-box_title">{{ f.folder.name | trim }}</div>
								</div>
							</div>
						</div>
						<div class="other-container">
							<div class="other" @click="goto('/browse/folders')">
								<div class="other-icon">
									<md-icon class="md-size-3x">add</md-icon>
								</div>
								<div class="other-text">{{ $t("other-folders") }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="docs">
					<div class="docs-title">{{ $t("documents") }}</div>
					<div class="docs-container">
						<div class="box-container">
							<div v-if="expired">
								<div
									style="
										display: flex;
										width: 100%;
										justify-content: space-around;
										align-items: center;
										height: 100%;
									"
								>
									<div>
										<md-icon class="md-size-2x" style="color: #f56c6c">warning</md-icon>
									</div>
									<div style="font-size: 1.2em; margin-left: 10px; font-weight: 500">
										{{ $t("expired-subscription-content") }}
									</div>
								</div>
							</div>
							<div
								class="box2"
								v-for="(d, i) in docs"
								:key="i"
								@click="viewInfo(d.Id, d.UniqueID)"
								v-else
							>
								<div class="docs-icon">
									<md-icon class="md-size-3x" style="color: #1a73e8">description</md-icon>
								</div>
								<div style="display: flex; height: 100%; align-items: flex-end; text-align: center">
									<div class="docs-box_title">{{ d.Title | trim }}</div>
								</div>
							</div>
						</div>
						<div class="other-container">
							<div class="other" @click="goto('/browse/all-docs')">
								<div class="other-icon">
									<md-icon class="md-size-3x">add</md-icon>
								</div>
								<div class="other-text">{{ $t("other-documents") }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<el-dialog
				:key="showModalRender + uuid()"
				:title="$t('preview')"
				:visible.sync="showModalRender"
				width="80%"
			>
				<span slot="title"><i class="el-icon-document" style="margin-right: 10px"></i>{{ $t("preview") }}</span>
				<anteprima
					v-if="showModalRender"
					:key="showModalRender + uuid()"
					:doc_id="selected_to_prev"
					:unique="selected_to_prev_unique"
				></anteprima>
				<span slot="footer">
					<el-button
						type="success"
						@click="
							showModalRender = !showModalRender
							documentPopup = !documentPopup
						"
						>{{ $t("add-to-project") }}</el-button
					>
					<el-button style="margin-left: 20px" type="primary" @click="showModalRender = false">{{
						$t("close")
					}}</el-button>
				</span>
			</el-dialog>

			<add-document :show="documentPopup" @close="documentPopup = !documentPopup" :docId="docId" />
		</div>
	</div>
</template>

<script>
import axios from "axios"
import img from "/src/assets/hero.svg"
import { goto } from "@/utils/utils"
import { uuid } from "@/modules/builder/utils/utils"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import FoldersSidebar from "@/modules/browse/components/sidebar-components/browse-sidebar.vue"
import AddDocument from "@/modules/browse/components/modals/browse-add-document"
import Anteprima from "@/modules/documents/anteprima"
import Search from "@/modules/browse/components/search"

export default {
	name: "browse-layout",
	components: {
		ButtonCollapseSidebar,
		FoldersSidebar,
		AddDocument,
		Anteprima,
		Search
	},
	data() {
		return {
			selected_to_prev: undefined,
			selected_to_prev_unique: undefined,
			img,
			numbers: { docs: 0, folders: 0 },
			widthScreen: window.innerWidth - 150,
			sidebar: true || window.innerWidth < 900,
			docsSearch: "",
			docs: [],
			folders: [],
			visible: false,
			showModalRender: false,
			documentPopup: false,
			docId: undefined,
			expired: false
		}
	},
	created() {
		this.getHome()
	},
	computed: {
		computedText: function () {
			return this.$t("browse-counter")
				.replace("%FOLDERSNUMBER%", this.numbers.folders)
				.replace("%DOCUMENTSNUMBER%", this.numbers.docs)
		}
	},
	methods: {
		goto,
		uuid,
		getHome() {
			this.docs = this.folders = []
			this.numbers = { docs: 0, folders: 0 }
			const payload = {
				search: "",
				pagination: {
					offset: 0,
					size: 4
				}
			}
			axios
				.post(`${process.env.VUE_APP_API_URL}/api/flowchart/getBySubscription`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					if (res.data.flowcharts === 0) {
						this.expired = true
					}
					this.numbers.docs = res.data.total
					this.docs = res.data.flowcharts
				})
			axios
				.post(`${process.env.VUE_APP_API_URL}/api/folders/getBySubscription`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					if (res.data.items === 0) this.expired = true
					this.numbers.folders = res.data.total
					this.folders = res.data.items
				})
		},
		viewInfo(id, unique) {
			this.docId = id
			axios
				.get(`${process.env.VUE_APP_API_URL}/api/flowchart/getSaved/${id}`, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					this.selected_nodes = []
					res.data.items.dati.forEach((el, index) => {
						if (el.value) {
							var tttmp = { id: 0, items: [], name: "" }
							el.value.forEach(el78 => {
								tttmp.items.push(JSON.parse(el78.items))
							})
							el.value = [tttmp]
						}
						el.id = index
						this.selected_nodes.push(el)
					})

					this.selected_to_prev = id
					this.selected_to_prev_unique = unique
					this.showModalRender = true
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
				})
		}
	},
	filters: {
		trim: function (el) {
			if (el && el.length > 40) return el.substring(0, 40) + "..."
			else return el
		}
	}
}
</script>

<style scoped lang="scss">
@mixin center() {
	display: flex;
	justify-content: center;
	width: 100%;
}

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.main {
	height: calc(100vh - 100px);
	display: flex;
	flex-direction: column;
	margin-top: -25px;
}

.hero {
	height: 45%;
	display: flex;
	width: 100%;

	.left {
		width: 60%;
		@include center;
		flex-direction: column;
		align-items: center;
		padding: 15px;

		.hero-title,
		.hero-subtitle {
			width: 70%;
		}

		.browse-home-input {
			width: 70%;
			height: 60px;
		}
	}

	.right {
		width: 40%;
		display: flex;
		justify-content: flex-start;

		img {
			margin-top: 40px;
			object-fit: contain;
			width: 90%;
			height: 90%;
		}
	}
}

.content {
	width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;

	.folders {
		height: 50%;

		.folders-title {
			font-size: 1.25rem;
			font-weight: 600;
			margin: 5px 15px;
		}

		.folders-container {
			display: flex;
			justify-content: space-around;
			margin: 15px 0;

			.box-container {
				display: flex;
				align-items: center;
				justify-content: space-around;
				width: 90%;

				.box1 {
					padding: 1pt;
					width: 80%;
					height: 150px;
					display: flex;
					flex-direction: column;
					cursor: pointer;
					transition: 0.25s border ease-in-out;

					.folders-icon {
						@include center;
						align-items: flex-start;
					}

					.folders-box_title {
						@include center;
						font-weight: 600;
						padding: 1pt;
						font-size: 1.1rem;
						height: 100%;
						align-items: flex-end;
						word-break: break-word;
					}
				}
			}

			.other-container {
				width: 20%;
			}
		}
	}

	.docs {
		height: max-content;

		.docs-title {
			font-size: 1.25rem;
			font-weight: 600;
			margin: 5px 15px;
		}

		.docs-container {
			display: flex;
			justify-content: space-around;
			margin: 15px 0;

			.box-container {
				display: flex;
				align-items: center;
				justify-content: space-around;
				width: 90%;

				.box2 {
					padding: 1.25pt;
					width: 80%;
					height: 150px;
					display: flex;
					flex-direction: column;
					cursor: pointer;
					transition: 0.25s border ease-in-out;

					.docs-icon {
						@include center;
					}

					.docs-box_title {
						@include center;
						font-weight: 600;
						padding: 1pt;
						font-size: 1.1rem;
						height: 100%;
						align-items: flex-end;
						word-break: break-word;
					}
				}
			}

			.other-container {
				width: 20%;
			}
		}
	}
}

.other {
	padding: 2pt;
	border: 1pt solid #ccc;
	border-radius: 10px;
	width: 150px;
	height: 140px;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	transition: 0.25s border ease-in-out;

	& :hover {
		border-width: 2pt;
		border-color: #ff8a65;
	}

	.other-icon {
		@include center;
	}

	.other-text {
		font-size: 1rem;
		font-weight: 600;
		height: 100%;
		@include center;
		align-items: center;
		text-align: center;
	}
}
</style>
